<template>
  <div>
    <TopBar></TopBar>

    <el-main style="width: 1200px;margin: 0 auto">
      <el-card style="height: 400px;">
        <div v-if="cardShow">
          <div style="width: 100%;height: 200px;">
            <!--  左侧图片  -->
            <div style="width:400px;height: 100%;float: left;margin-left: 100px">
              <img :src="course_detail[0].img" alt="" style="width: 100%;height: 100%;border-radius: 5px">
            </div>

            <!--  右侧介绍  -->
            <div style="width: 550px;height:100%;background-color:white;margin-left: 600px;border-radius: 20px;">
              <h1>《 {{ course_detail[0].title }} 》</h1>
              <p style="color: gray;display: none;">id:{{ course_id }}</p>
              <h2 style="color: red;" v-if="course_detail[0].price == '0'" >免费课程</h2>
              <h2 style="color: red;" v-if="course_detail[0].price != '0'">{{ course_detail[0].price }}元</h2>
              <h4>共 {{ course_detail.length }} 节</h4>
              <el-button type="primary" v-if="show" @click="addCourse">购买课程</el-button>
              <el-button type="primary" v-if="!show" @click="toPlayer(course_id,course_detail[0].chapter_id,course_detail[0].price)">开始学习</el-button>
            </div>
          </div>

          <!--   下方课程简介    -->
          <div style="width: 100%;background-color: white;margin-top: 50px;border-radius: 30px;display:none">
            <el-divider></el-divider>

            <h2>课程简介</h2>
            <p>{{ course_detail[0].info }}</p>
            <el-divider></el-divider>
            <ul v-for="i in course_detail">
              <li @click="toPlayer(course_id,i.chapter_id,i.price)" style="color: #409EFF">
                {{ i.chapter_title }} - {{ course_detail[0].title }}
              </li>
            </ul>

            <div style="width: 100%;height: 150px"></div>
          </div>
        </div>

        <div style="height: 600px" v-show="emptyShow">
          <el-empty description="课程暂时没有上架"></el-empty>
        </div>
      </el-card>
    </el-main>

    <FootBar></FootBar>
  </div>
</template>

<script>
import {Message, MessageBox} from "element-ui";
import TopBar from "../layout/TopBar"
import FootBar from "../layout/FootBar";
import jwt from 'jsonwebtoken'

export default {
  name: "ClassInfo",
  components: {
    TopBar,
    FootBar
  },

  data() {
    return {
      course_id: this.$route.params.id,
      course_detail: '',
      cardShow: true,
      emptyShow: '',
      show:false
    }
  },
  created() {
    this.getCourseDetail()
    this.getIsShow()
  },

  methods: {
    //  根据课程id查询详情页数据
    async getCourseDetail() {
      let course_id = this.course_id;
      const {data: res} = await this.$http.get(`/courses/${course_id}`)
      console.log(res.data)
      this.course_detail = res.data;
      if (this.course_detail.length !== 0) {
        this.emptyShow = false
      } else {
        this.emptyShow = true
        this.cardShow = false
      }
    },

    // 购买课程
    addCourse() {
      const tokenStr = sessionStorage.getItem('token')
      if (!tokenStr) {
        Message.error("请先登陆")
      } else {
        MessageBox.confirm('观看该课程，请联系客服?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/courses')
        })
      }
    },
    //是否购买课程
    getIsShow(){
      const tokenStr = sessionStorage.getItem('token')
      if(tokenStr){
        let uid = jwt.decode(tokenStr).uid
        let course_id = this.course_id
        this.$http.post(`/users/${uid}/isPurchase/${course_id}`).then(res => {
            console.log(res.data.data)
          if (res.data.data === 0) {
            this.show = true;
          }
        })
      }
    },
    // 转跳到播放页
    toPlayer(course_id, chapter_id,price) {
      let token = sessionStorage.getItem("token")
      if(!token){
        Message.error("请先登录")
      }else{
        if(price != 0){
          //查询是否加入课程
          let uid = jwt.decode(token).uid
          this.$http.post(`/users/${uid}/isPurchase/${course_id}`).then(res => {
            if (res.data.data === 0) {
              Message.error("课程还未购买,请联系客服")
            }else{
              this.$router.push('/courses/' + course_id + '/chapter/' + chapter_id)
            }
          })
        }else{
          this.$router.push('/courses/' + course_id + '/chapter/' + chapter_id)
        }
      }
    }
  }
}
</script>

<style scoped>
  li {
    list-style-type:none;
  }
</style>
